import React from 'react';

export default function AccessDenied() {
  return <div>Access denied !!!! Please login with proper credentials</div>;
}
